import React from 'react';
import Link from 'next/link';
import Modal from '@common/modal';
import Text from '@common/text';
import CloseButton from '@components/common/closeButton';
import { AccNeedAdditionalModalExpiresKey } from '..';
import { FontStyle } from '@domain/constant/fontStyle';
import Colors from '@domain/constant/colors';
import { MILLISECONDS_PER_DAY } from '@domain/constant/Time';
import useLocalStorageExpires from '@utils/hooks/useLocalStorageExpires';
import useModal from '@utils/hooks/useModal';
import { RouteUrl } from '@utils/routeUtil';
import classnames from 'classnames/bind';
import styles from './index.module.scss';

const cx = classnames.bind(styles);

const AccNeedAdditionalModal = ({ visible }: { visible: boolean }) => {
  const { closeModal, isModalOpen } = useModal(visible);
  const { setExpires } = useLocalStorageExpires();

  const handleExpires = () => {
    setExpires({ key: AccNeedAdditionalModalExpiresKey, expires: MILLISECONDS_PER_DAY * 7 });
    closeModal();
  };

  return (
    <Modal visible={isModalOpen} dimmed={true}>
      <div className={cx('modalArea')}>
        <CloseButton className={cx('btnClose')} onClick={closeModal} />
        <a className={cx('btnClose')} role="button" onClick={closeModal}>
          <span className={cx('hidden')}>close</span>
        </a>

        <Text fontStyle={FontStyle.H4_B}>추가 응시하고 역검 결과표 받아가세요!</Text>
        <Text className={cx('subText')} fontStyle={FontStyle.B2P_M} color={Colors.C_COOL_GRAY_70}>
          <>
            결과표 생성을 위해서는 추가 응시가 필요해요. <br />
            최근 응시 내역에서 추가 응시가 필요한 역검 결과를 확인해 주세요.
          </>
        </Text>

        <div className={cx('img')} />

        <Link className={cx('resumeBtn')} href={RouteUrl.ACCA_TEST_LIST} target="blank" onClick={closeModal}>
          추가 과제 응시하기
        </Link>

        <div className={cx('expiresArea')}>
          <button className={cx('expiresBtn')} onClick={handleExpires}>
            일주일 동안 보지 않기
          </button>
        </div>
      </div>
    </Modal>
  );
};

export default AccNeedAdditionalModal;
